import React, { useState } from 'react';
import { Modal, FormGroup } from 'react-bootstrap';
import ErrorAlert from './error_alert';

export default function JobTitleModal({ closeModal, id, label, submitForm, error }: JobTitleModalProps) {
  const [jobTitleLabel, setJobTitleLabel] = useState(label || '');

  const submit = (e) => {
    e.preventDefault();
    submitForm({ id, label: jobTitleLabel });
  };

  const canSubmitForm = jobTitleLabel !== '';

  return (
    <Modal.Body className="p-5">
      <h2 className="text-center mt-0 mb-4">{id === '' ? 'Add a' : 'Edit'} Job Title</h2>
      <ErrorAlert error={error}/>
      <form onSubmit={submit}>
        <FormGroup>
          <label htmlFor="job-title-label">Add Job Title</label>
          <input
            autoFocus
            className="form-control"
            id="job-title-label"
            placeholder="Enter job title"
            value={jobTitleLabel}
            onChange={e => setJobTitleLabel(e.target.value)}
          />
        </FormGroup>
        <div className="d-flex">
          <button className="btn btn-secondary mr-2" type="button" onClick={closeModal}>Cancel</button>
          <button className="btn btn-primary" disabled={!canSubmitForm} type="submit">Add Job Title</button>
        </div>
      </form>
    </Modal.Body>
  );
}

type JobTitleModalProps = {
  closeModal: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void,
  error: string,
  id?: string | number,
  label?: string,
  submitForm: Function
};
